// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_ee-3";
export var flatBottomCorners = "_ee-5";
export var productImage = "_ee-0";
export var quantityContainer = "_ee-2";
export var quantityHeader = "_ee-6";
export var tooltip = "_ee-1";
export var wrapAndEllipsesOverflow = "_ee-4";